jQuery(document).ready(function ($) {
  $('.hamburger').on('click', function () {
    if (!$(this).hasClass('is-active')) {
      $(this).addClass('is-active');
      $('.header-nav').addClass('header-nav--active');
      $('body, .site').addClass('menu-active');
    }
    else {
      $(this).removeClass('is-active');
      $('.header-nav').removeClass('header-nav--active');
      $('body, .site').removeClass('menu-active');
      $(".submenu-content").removeClass("submenu-active");
      $('.header-back-button').removeClass('show-back-button');
    }
  });
  if (screen.width < 1025) {
    $(".nav-link.has-submenu .menu-after").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      let submenu = $(this).closest(".nav-link").next(".submenu-content");

      if (submenu.length > 0) {

        $(".submenu-content").removeClass("submenu-active");

        submenu.addClass("submenu-active");
        $('.header-back-button').addClass('show-back-button');
      }
    });

    $('.header-back-button').on('click', function (e) {
      e.preventDefault();
      $(".submenu-content").removeClass("submenu-active");
      $(this).removeClass('show-back-button');
    });
  }





});